import React, { FC } from "react"
import { JourneyTalkedToDoctorContainer } from "components/views/fle/journey/JourneyTalkedToDoctorContainer"
import L10n from "../../../../lib/carrot-l10n"
import { useHistory } from "react-router-dom"
import { JourneyPaths } from "./JourneyPaths"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const JourneyStartedSeeingDoctor: FC = () => {
  const history = useHistory()
  return (
    <JourneyTalkedToDoctorContainer
      title={l`Have you started seeing a doctor yet?`}
      next={JourneyPaths.DONE}
      history={history}
    />
  )
}

export { JourneyStartedSeeingDoctor }
